import React from 'react';
import { IFormValueServiceItem } from '../types';
import styled from 'styled-components';
import ic_staff from './ic_staff.png';
import ic_change from './ic_change.png';
import { Avatar } from 'antd';
import anybody_icon from 'assets/Icons/icon-anybody.png';
import { ANY_BODY_ID_STORE_LIST } from 'features/booking/services/constants';
import Box from 'components/Box';

type Props = {
  value?: IFormValueServiceItem;
  name?: any;
  onChangeStaff: (o?: IFormValueServiceItem) => void;
};
const CustomerServiceItem = ({ value, onChangeStaff }: Props) => {
  return (
    <ServiceItemStyled>
      <div className="service-info">
        <Box display='flex' alignItems='center' gap='1'>
          <p className="service-name">{value?.serviceName}</p>
          <p className="service-duration">({value?.duration}m)</p>
        </Box>
        <p className="service-duration start-end-time">{value?.startTime || '--'} - {value?.endTime || '--'}</p>
      </div>
      {
        value?.staffId ? (
          <button type='button' onClick={() => onChangeStaff(value)} className="service-staff-info">
            <Avatar src={ANY_BODY_ID_STORE_LIST.includes(value?.staffId) ? anybody_icon : (value?.staffAvatar ? value?.staffAvatar : undefined)} alt="img_staff_avatar" size={40}>
              {value?.staffName?.[0] || ''}
            </Avatar>
            <p className="staff-name">{value?.staffName}</p>
            <img src={ic_change} alt="ic_change" style={{ width: '24px', height: '24px' }} />
          </button>
        ) : (
          <button type='button' onClick={() => onChangeStaff(value)} className="service-staff-info">
            <img src={ic_staff} alt="ic_staff" style={{ width: '40px', height: '40px', borderRadius: '100%' }} />
            <p className="select-staff">Select staff</p>
          </button>
        )
      }
    </ServiceItemStyled>
  );
};

export default CustomerServiceItem;

const ServiceItemStyled = styled.div`
display: flex;
padding-bottom: 8px;
align-items: center;
gap: 16px;
align-self: stretch;
border-bottom: 1px solid #CCD4DC;

.service-info {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  p.service-name {
    color: #1D2129;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    align-self: stretch;
  }
  p.service-duration {
    color: #232F3E;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    align-self: stretch;
  }
}


.service-staff-info {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;

  .select-staff {
    color: #2463EB;
    text-align: right;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .staff-name {
    color: #1D2129;
    text-align: right;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
  }
}

`;
